import PropTypes from "prop-types";
import clsx from "clsx";




const FeatureIconFiveSingle = ({ data, spaceBottomClass }) => {
  //console.log(data)
  return (
    <div className={clsx("support-wrap-4", spaceBottomClass)}>

      <div className="support-icon-4">

        <img
          //className="animated"
          src={process.env.PUBLIC_URL + data.image}
          alt=""
        />
      </div>
      <div className="support-content-4 pt-20">
        <a href={data.link} target="_blank" rel="noreferrer">
        <h5>{data.title}</h5></a>
        <a href={data.link} target="_blank"  rel="noreferrer"><p>{data.subtitle}</p></a>

      </div>
    </div>
  );
};

FeatureIconFiveSingle.propTypes = {
  data: PropTypes.shape({}),
  spaceBottomClass: PropTypes.string
};

export default FeatureIconFiveSingle;
